import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button } from 'antd';
import generatePath from '~settings/routing';
import SvgFormat from '~helpers/svgFormat';
import { propertyDraftStatus } from '~constants/pending-approval';

export default class Draft extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isHover: false,
    };
  }

  getDraftStatus = () => {
    const { draft } = this.props;
    if (!draft.draftsStatus) {
      return '';
    }

    if (draft.draftsStatus.includes(propertyDraftStatus.EXPIRED)) {
      return propertyDraftStatus.EXPIRED.toLowerCase();
    }
    if (draft.draftsStatus.includes(propertyDraftStatus.REJECTED)) {
      return propertyDraftStatus.REJECTED.toLowerCase();
    }
    if (draft.draftsStatus.includes(propertyDraftStatus.PENDING)) {
      return propertyDraftStatus.PENDING.toLowerCase();
    }
    if (draft.draftsStatus.includes(propertyDraftStatus.APPROVED)) {
      return propertyDraftStatus.APPROVED.toLowerCase();
    }
    return propertyDraftStatus.PENDING.toLowerCase();
  };

  handleMouseEnterDraft = () => {
    this.setState({ isHover: true });
  };

  handleMouseLeaveDraft = () => {
    this.setState({ isHover: false });
  };

  handleClickCheck = () => {
    const { draft } = this.props;
    const url = generatePath('property.edit', { propertySlug: draft.propertySlug });
    this.props.history.push(url, {
      draftsCategory: draft.draftsCategory[0],
      draftsStatus: draft.draftsStatus[0],
    });
  };

  render() {
    const { t, draft } = this.props;
    const draftStatus = this.getDraftStatus();

    return (
      <div
        className="pending-approval__draft"
        onMouseEnter={this.handleMouseEnterDraft}
        onMouseLeave={this.handleMouseLeaveDraft}
      >
        <div className="pending-approval__draft-wrap">
          <div className="pending-approval__name">
            {draft.propertyName || ''}
            <If condition={draft.propertyPublished}>
              <span className="pending-approval__category">
                {draft.draftsCategory
                  ? t(`cms:cms.pending_approval.${draft.draftsCategory[0].toLowerCase()}`)
                  : ''}
              </span>
            </If>
          </div>
          <div className="pending-approval__city">
            <span className="pending-approval__blank">
              {draft.city && draft.city.name ? `${draft.city.name},` : ''}
            </span>
            <span className="pending-approval__blank">
              {draft.city && draft.city.country && draft.city.country.name
                ? `${draft.city.country.name},`
                : ''}
            </span>
            <span className="pending-approval__update-time">
              {draft.updatedAt ? moment(draft.updatedAt).format('DD/MM/YYYY') : ''}
            </span>
          </div>
          <If
            condition={
              draftStatus &&
              draftStatus !== propertyDraftStatus.APPROVED.toLowerCase() &&
              !this.state.isHover
            }
          >
            <span className="pending-approval__status-wrap">
              <SvgFormat
                className="pending-approval__draft-icon"
                type={`${draftStatus}-no-shadow`}
              />
              <span
                className={`
                pending-approval__draft-text
                pending-approval__draft-text--${draftStatus}
              `}
              >
                {t(`cms:cms.pending_approval.draft.status.${draftStatus}`)}
              </span>
            </span>
          </If>
          <If condition={this.state.isHover}>
            <Button
              type="primary"
              className="pending-approval__check"
              onClick={this.handleClickCheck}
            >
              {t('cms:cms.pending_approval.draft.check.btn')}
            </Button>
          </If>
        </div>
      </div>
    );
  }
}

Draft.propTypes = {
  t: PropTypes.func.isRequired,
  draft: PropTypes.object,
  history: PropTypes.object,
};

Draft.defaultProps = {
  t: () => {},
  draft: {},
  history: {},
};
